// StartQuizDialog.tsx
import {
  BookOpen,
  Play,
  Sparkles,
  User,
  CheckCircle2,
} from "lucide-react";
import { useState } from "react";

type Props = {
  selectedTopic: any;
  studentName: string;
  setStudentName: (value: string) => void;
  onClose: () => void;
  onStart: (name: string) => void;
};

export default function StartQuizDialog({
  selectedTopic,
  onClose,
  onStart,
}: Props) {
    const [name, setName] = useState("");
  return (
    <div className="p-2">
      {/* Hero */}
      <div
        className={`rounded-3xl p-6 text-white ${selectedTopic.color}`}
      >
        <div className="flex items-start justify-between gap-4">
          <div>
            <div className="w-14 h-14 rounded-2xl bg-white/20 backdrop-blur flex items-center justify-center mb-4">
              <BookOpen size={28} />
            </div>

            <h2 className="text-3xl font-bold mb-3">
              {selectedTopic.title}
            </h2>

            <p className="text-white/90 leading-relaxed">
              {selectedTopic.description}
            </p>
          </div>

          <Sparkles className="opacity-70" />
        </div>
      </div>

      {/* Student */}
      <div className="mt-6">
        <label className="text-sm font-semibold text-gray-600 mb-3 block">
          Student Name
        </label>

        <div className="relative">
          <User
            size={18}
            className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400"
          />

          <input
            autoFocus
            type="text"
            value={name}
onChange={(e) =>
  setName(e.target.value)
}
            placeholder="Enter your full name"
            className="w-full h-14 pl-12 pr-4 rounded-2xl border border-gray-200 bg-gray-50 focus:bg-white focus:outline-none focus:ring-2 focus:ring-emerald-500"
          />
        </div>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-2 gap-4 mt-6">
        <div className="rounded-2xl bg-gray-50 border p-5">
          <p className="text-gray-500 text-sm mb-2">
            Questions
          </p>

          <h3 className="text-3xl font-bold">
            {selectedTopic.questions.length}
          </h3>
        </div>

        <div className="rounded-2xl bg-gray-50 border p-5">
          <p className="text-gray-500 text-sm mb-2">
            Passing Score
          </p>

          <h3 className="text-3xl font-bold">
            {selectedTopic.passingPercentage}%
          </h3>
        </div>
      </div>

      {/* Features */}
      <div className="mt-6 space-y-3">
        <div className="flex items-center gap-3 text-sm text-gray-700">
          <CheckCircle2
            size={18}
            className="text-green-600"
          />
          Completion Certificate Included
        </div>

        <div className="flex items-center gap-3 text-sm text-gray-700">
          <CheckCircle2
            size={18}
            className="text-green-600"
          />
          Instant Result & Score
        </div>

        <div className="flex items-center gap-3 text-sm text-gray-700">
          <CheckCircle2
            size={18}
            className="text-green-600"
          />
          Explanation After Answers
        </div>
      </div>

      {/* Buttons */}
      <div className="flex gap-3 mt-8">
        <button
          onClick={onClose}
          className="flex-1 h-14 rounded-2xl border border-gray-300 font-semibold hover:bg-gray-100 transition"
        >
          Cancel
        </button>

        <button
          disabled={!name.trim()}
          onClick={() => onStart(name)}
          className={`flex-1 h-14 rounded-2xl text-white font-semibold flex items-center justify-center gap-2 transition disabled:opacity-50 ${selectedTopic.color}`}
        >
          <Play size={18} />
          Start Quiz
        </button>
      </div>
    </div>
  );
}